// extracted by mini-css-extract-plugin
export default {"container":"vid_3Kc9d","shape":"vid_sha_syaqd","video":"vid_vid_1osF3","vertical":"vid_ver_1pE84"};